import { render, staticRenderFns } from "./regular.vue?vue&type=template&id=71f744b4&scoped=true"
import script from "./regular.vue?vue&type=script&lang=js"
export * from "./regular.vue?vue&type=script&lang=js"
import style0 from "./regular.vue?vue&type=style&index=0&id=71f744b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f744b4",
  null
  
)

export default component.exports